class CartDiscount extends HTMLElement {
  connectedCallback() {
    this.querySelector('form').addEventListener('submit', event => {
      event.preventDefault();
      this.apply(this.querySelector('input').value.trim());
    });
    this.querySelector('[data-remove]').addEventListener('click', () => this.apply(''));
  }

  async apply(code) {
    if (this.busy) return;
    this.busy = true;
    const messages = { ...this.dataset };
    const drawer = this.closest('cart-drawer');
    const buttons = [...this.querySelectorAll('button')];
    buttons.forEach(button => button.disabled = true);
    this.querySelector('[role=status]').textContent = '';
    try {
      const response = await fetch(window.routes.cart_update_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ discount: code, sections: drawer.getSectionsToRender().map(section => section.id), sections_url: location.pathname })
      });
      const cart = await response.json();
      if (!response.ok || cart.errors) throw new Error('Discount update failed');
      // A 200 response alone doesn't mean Shopify accepted the code.
      const applied = cart.discount_codes?.some(discount => discount.code.toLowerCase() === code.toLowerCase() && discount.applicable);
      drawer.renderContents(cart, { openOnAdd: false });
      const replacement = drawer.querySelector('cart-discount');
      replacement.querySelector('input').value = code;
      replacement.querySelector('input').setAttribute('aria-invalid', String(Boolean(code && !applied)));
      replacement.querySelector('[role=status]').textContent = code ? (applied ? messages.success : messages.invalid) : messages.removed;
      replacement.querySelector('[data-remove]').hidden = !code;
      replacement.querySelector('input').focus();
      await publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-discount', cartData: cart });
    } catch (error) {
      this.querySelector('[role=status]').textContent = messages.error;
    } finally {
      this.busy = false;
      buttons.forEach(button => button.disabled = false);
    }
  }
}
customElements.define('cart-discount', CartDiscount);
